import { render } from "./NotificationBannerStack.vue?vue&type=template&id=5663df7f&scoped=true"
import script from "./NotificationBannerStack.vue?vue&type=script&lang=js"
export * from "./NotificationBannerStack.vue?vue&type=script&lang=js"

import "./NotificationBannerStack.vue?vue&type=style&index=0&id=5663df7f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5663df7f"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QBtn});
